import { formatImage, formatImageAccurate } from '@ifeng-fe/public_method';

const maxSize = 4 * 1024 * 1024;
const defaultQuality = 90;

interface GetImageUrlModel {
    url: string;
    width?: number | null;
    height?: number | null;
    size?: number | null;
}

interface ImageUrlModel {
    url: string;
    width?: number | null;
    height?: number | null;
}

const getCommentImageUrl = (args: GetImageUrlModel): ImageUrlModel => {
    const { url: initUrl, width, height, size } = args;
    try {
        let url = initUrl;
        const imgWidth = width ?? 0;
        const imgHeight = height ?? 0;
        const rate = !isNaN(imgWidth / imgHeight) ? imgWidth / imgHeight : 0;
        const isAddWebp = Boolean(size && size > 0 && size < maxSize);
        let formatWidth: number;
        let formatHeight: number;

        if (rate < 0.46) {
            formatWidth = 480;
            formatHeight = 642;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: '0',
                          aiy: '0',
                          aiw: width ?? undefined,
                          aih: width ? Math.round(width / (480 / 642)) : undefined,
                          isAddWebp,
                      });
        } else if (rate < 0.75) {
            formatWidth = 480;
            formatHeight = 642;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: '0',
                          aiy: `${width && height ? Math.max(height - Math.round(width / (480 / 642)), 0) : 0}`,
                          aiw: width ?? undefined,
                          aih: width ? Math.round(width / (480 / 642)) : undefined,
                          isAddWebp,
                      });
        } else if (rate >= 0.75 && rate <= 1.78) {
            formatWidth = 645;
            formatHeight = Math.round(642 / rate);
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImage(url.replace(/_webp/g, ''), formatWidth, formatHeight, defaultQuality, isAddWebp);
        } else {
            formatWidth = 642;
            formatHeight = 360;
            url = url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: `${width && height ? Math.max(width - Math.round((height * 642) / 360), 0) : 0}`,
                          aiy: '0',
                          aiw: height ? Math.round((height * 642) / 360) : undefined,
                          aih: height ?? undefined,
                          isAddWebp,
                      });
        }
        return { url, width: formatWidth, height: formatHeight };
    } catch (e) {
        return { url: initUrl, width, height };
    }
};

const getOnlyImageUrl = (args: GetImageUrlModel): ImageUrlModel => {
    const { url: initUrl, width, height, size } = args;

    try {
        let url = initUrl;
        const imgWidth = width ?? 0;
        const imgHeight = height ?? 0;
        const rate = !isNaN(imgWidth / imgHeight) ? imgWidth / imgHeight : 0;
        const isAddWebp = Boolean(size && size > 0 && size < maxSize);
        let formatWidth: number;
        let formatHeight: number;

        if (rate < 0.46) {
            formatWidth = 1005;
            formatHeight = 1341;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: '0',
                          aiy: '0',
                          aiw: width ?? undefined,
                          aih: width ? Math.round(width / (228 / 344)) : undefined,
                          isAddWebp,
                      });
        } else if (rate >= 0.46 && rate <= 1.78) {
            formatWidth = 1005;
            formatHeight = Math.round(1005 / rate);
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImage(url.replace(/_webp/g, ''), formatWidth, formatHeight, defaultQuality, isAddWebp);
        } else {
            formatWidth = 1005;
            formatHeight = 567;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: `${width && height ? Math.max(Math.round((width - height * (1005 / 567)) / 2), 0) : 0}`,
                          aiy: '0',
                          aiw: height ? Math.round(height * (1005 / 567)) : undefined,
                          aih: height ?? undefined,
                          isAddWebp,
                      });
        }

        return { url, width: formatWidth, height: formatHeight };
    } catch (e) {
        return { url: initUrl, width, height };
    }
};

const getTwoImageUrl = ({ url: initUrl, width, height, size }: GetImageUrlModel): ImageUrlModel => {
    try {
        let url = initUrl;
        const imgWidth = width ?? 0;
        const imgHeight = height ?? 0;
        const isAddWebp = Boolean(size && size > 0 && size < maxSize);
        let formatWidth: number;
        let formatHeight: number;

        if (imgWidth > imgHeight) {
            formatWidth = 495;
            formatHeight = 576;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: `${width && height ? Math.max(Math.round((width - height * (495 / 576)) / 2), 0) : 0}`,
                          aiy: '0',
                          aiw: height ? Math.round(height * (495 / 576)) : undefined,
                          aih: height ?? undefined,
                          isAddWebp,
                      });
        } else {
            formatWidth = 495;
            formatHeight = 576;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: '0',
                          aiy: `${
                              width && height
                                  ? Math.max(Math.round((height - Math.round(width / (495 / 576))) / 2), 0)
                                  : 0
                          }`,
                          aiw: width ?? undefined,
                          aih: width ? Math.round(width / (495 / 576)) : undefined,
                          isAddWebp,
                      });
        }

        return { url, width: formatWidth, height: formatHeight };
    } catch (e) {
        return { url: initUrl, width, height };
    }
};

const getFourImageUrl = ({ url: initUrl, width, height, size }: GetImageUrlModel): ImageUrlModel => {
    try {
        let url = initUrl;
        const imgWidth = width ?? 0;
        const imgHeight = height ?? 0;
        const isAddWebp = Boolean(size && size > 0 && size < maxSize);
        let formatWidth: number;
        let formatHeight: number;

        if (imgWidth > imgHeight) {
            formatWidth = 495;
            formatHeight = 276;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: `${width && height ? Math.max(Math.round((width - height * (495 / 276)) / 2), 0) : 0}`,
                          aiy: '0',
                          aiw: height ? Math.round(height * (495 / 276)) : undefined,
                          aih: height ?? undefined,
                          isAddWebp,
                      });
        } else {
            formatWidth = 495;
            formatHeight = 276;
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImageAccurate({
                          url: url.replace(/_webp/g, ''),
                          width: formatWidth,
                          height: formatHeight,
                          aix: '0',
                          aiy: `${width && height ? Math.max(Math.round((height - width / (495 / 276)) / 2), 0) : 0}`,
                          aiw: width ?? undefined,
                          aih: width ? Math.round(width / (495 / 276)) : undefined,
                          isAddWebp,
                      });
        }

        return { url, width: formatWidth, height: formatHeight };
    } catch (e) {
        return { url: initUrl, width, height };
    }
};

const getInitialImageUrl = ({ url: initUrl, width, height, size }: GetImageUrlModel) => {
    try {
        let url = initUrl;
        const isAddWebp = Boolean(size && size > 0 && size < maxSize);

        if (width && height) {
            url =
                url.indexOf('.gif') > -1
                    ? url.replace(/_webp/g, '')
                    : formatImage(url.replace(/_webp/g, ''), width, height, defaultQuality, isAddWebp);
        }

        return url;
    } catch (e) {
        return initUrl;
    }
};

export interface ImageModel {
    url?: string | null;
    width?: number | null;
    height?: number | null;
    size?: number | null;
    // scene?: 'content' | 'normal' | 'summary' | null;
}

export interface ImageInitialModel {
    initialUrl: string;
    url: string;
    width?: number | null;
    height?: number | null;
    initialWidth?: number | null;
    initialHeight?: number | null;
}

const getImageInfo = (image: ImageModel) => {
    let { url = '' } = image;
    const { width, height, size } = image;

    url = url ?? '';

    try {
        const imgReg = ((url.split('/').pop() as string).split('.').shift() as string).split('_');

        let imgWidth = width;
        let imgHeight = height;
        let imgSize = size;

        imgReg.forEach((item) => {
            if (!imgWidth && /^w\d+$/.test(item)) {
                imgWidth = parseInt(item.replace('w', ''));
            } else if (!imgHeight && /^h\d+$/.test(item)) {
                imgHeight = parseInt(item.replace('h', ''));
            } else if (!imgSize && /^size\d+$/.test(item)) {
                imgSize = parseInt(item.replace('size', ''));
            }
        });

        return { width: imgWidth, height: imgHeight, size: imgSize };
    } catch (e) {
        console.error(e);

        return { width, height, size };
    }
};

export const getFormatImages = (images: ImageModel[], options: { isComment?: boolean } = {}) => {
    try {
        const newImages: ImageInitialModel[] = [];
        const { isComment } = options;

        images.forEach((item, index, array) => {
            let { url = '', width: imgWidth, height: imgHeight, size: imgSize } = item;

            url = url ?? '';

            let isLongImage = false;
            let isGifImage = false;
            let initialUrl = url;
            const initialWidth = imgWidth;
            const initialHeight = imgHeight;

            if (url && (url.indexOf('ifeng-cos-ugc-upload') > -1 || url.toLowerCase().indexOf('heic') > -1)) {
                newImages.push({
                    initialUrl: url,
                    url,
                    width: imgWidth,
                    height: imgHeight,
                    initialWidth,
                    initialHeight,
                });

                return;
            }

            if (url.indexOf('.gif') > -1) {
                isGifImage = true;
            }

            if (!imgWidth || !imgHeight || !imgSize) {
                const { width, height, size } = getImageInfo(item);

                imgWidth = width;
                imgHeight = height;
                imgSize = size;
            }

            if (imgWidth && imgHeight && (imgWidth / imgHeight < 0.66 || imgWidth / imgHeight > 2)) {
                isLongImage = true;
            }

            let imageInfo: ImageUrlModel;

            if (array.length == 1) {
                imageInfo = isComment
                    ? getCommentImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize })
                    : getOnlyImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize });
            } else if (array.length == 2) {
                imageInfo = getTwoImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize });
            } else if (array.length == 3) {
                imageInfo =
                    index == 0
                        ? getTwoImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize })
                        : getFourImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize });
            } else {
                imageInfo =
                    index < 4
                        ? getFourImageUrl({ url, width: imgWidth, height: imgHeight, size: imgSize })
                        : {
                              url,
                              width: imgWidth,
                              height: imgHeight,
                          };
            }

            url = imageInfo.url;

            initialUrl = getInitialImageUrl({ url: initialUrl, width: imgWidth, height: imgHeight, size: imgSize });

            newImages.push({
                initialUrl,
                url,
                width: imgWidth,
                height: imgHeight,
                initialWidth,
                initialHeight,
            });
        });

        return newImages;
    } catch (e) {
        return [];
    }
};
